module.exports = __webpack_public_path__ + "static/Sonid-Logo-661c279038d86b251407870c6d174d44.gif";